import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage'; 
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";

import { isLocal } from './config';
import { resolve, ANALYTICS_ENABLED } from './firebase-projects';

// live: prmassist-portal.  sandbox: prm-sandbox-env.  sgs: prmassist-sgs.
const firebaseConfig = resolve('portal');

try {
    firebase.initializeApp(firebaseConfig);
  } catch (err) {
    if (!/already exists/.test(err.message)) {
      console.error('Firebase initialization error', err.stack);
    }
  }

const fire = firebase;
export default fire;

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);

if (ANALYTICS_ENABLED) {
  try {
    getAnalytics(app);
  } catch (e) {
    if (!/already exists/.test(e.message)) {
      console.warn('Firebase Analytics unavailable:', e.message);
    }
  }
}

let emulatorsConnected = false;
if (isLocal && !emulatorsConnected) {
  emulatorsConnected = true;
  console.log(`Emulator mode — connecting portal app (${firebaseConfig.projectId}) to Firebase emulators`);

  connectAuthEmulator(getAuth(app), 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(getFirestore(app), 'localhost', 8080);
  connectStorageEmulator(storage, 'localhost', 9199);

  firebase.auth().useEmulator('http://localhost:9099');
  firebase.firestore().useEmulator('localhost', 8080);
}
